export default {
  namespaced: true,
  state: {
    id: '1eb12dcb-9b2b-4ede-823f-cc1f6a148905',
  },
  mutations: {},
  actions: {},
  getters: {},
};
